// import memoize from "fast-memoize";
import React, { useCallback, useMemo, useState } from "react";

export function useForm(pass) {
  const {
    inValidate,
    val,
    dyncVals,
    withSubmit,
    inDyncValidate,
    inDyncCheckValidate,
  } = pass || {};

  const { items, setItems, arrItems } = dyncVals || {};

  const [state, setState] = useState(val);
  // const state = React.useRef(val);
  const [isSubmit, setIsSubmit] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const MobileRegex = /^[0-9]*$/;

  const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

  const noSpCharsRegex = /[^a-zA-Z0-9]/;

  const handleInputChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const handleInputDynamic = (ind, e) => {
    let name = e.target.name.split("[]")[0];
    let update = items;
    if (items !== undefined && items !== null) {
      update[ind][name] = e.target.value;
      let arr = [...items.slice(0, ind), update[ind], ...items.slice(ind + 1)];
      setItems(arr);
    }
  };

  const checkDyncErrors = (ind, e) => {
    let name = e.target.name.split("[]")[0];
    let obj = {};
    if (formErrors[ind] !== undefined) {
      obj = formErrors[ind];
    } else {
      obj = {};
    }

    if (items !== undefined && items !== null) {
      if (items[ind][name]?.trim() === "") {
        let msg = name.split(/(?=[A-Z])/);
        if (msg.length > 1) {
          msg = msg.join(" ");
        }
        obj[name] = `${msg} Is Required!`;
        if (msg[0] === "Dob") {
          obj[name] = "Date of birth is required!";
        }

        //temp

        // if (
        //   items[ind]["IdType"].trim() === "" &&
        //   items[ind]["IdNumber"].trim() === "" &&
        //   items[ind]["IdIssueDate"].trim() === "" &&
        //   items[ind]["IdExpiryDate"].trim() === "" &&
        //   (items[ind]["PassengerType"] === 2 ||
        //     items[ind]["PassengerType"] === 3)
        // ) {
        //   delete obj[name];
        // }
      } else {
        if (name === "Email" && e.target.value.trim() !== "") {
          if (!emailRegex.test(e.target.value)) {
            obj[name] = "Please enter a valid email!";
          } else {
            delete obj[name];
          }
        }

        if (name === "MobileNo" && e.target.value.trim() !== "") {
          if (e.target.value.length >= 6 && e.target.value.length <= 10) {
            obj[name] = "Please Enter Valid Number!";
          } else if (!MobileRegex.test(e.target.value)) {
            obj[name] = "Only numbers are allowed!";
          } else {
            delete obj[name];
          }
        }
        //inDyncCheckValidate

        if (inDyncCheckValidate !== null && inDyncCheckValidate !== undefined) {
          obj = inDyncCheckValidate(name, noSpCharsRegex, e, obj, ind);
        }

        // if (
        //   name === "IdNumber" &&
        //   e.target.value.trim() !== "" &&
        //   obj["IdType"] === undefined
        // ) {
        //   if (
        //     e.target.value.length < 6 ||
        //     e.target.value.length > 15 ||
        //     e.target.value.includes(" ") ||
        //     noSpCharsRegex.test(e.target.value)
        //   ) {
        //     obj[name] = "Invalid Passport Number!";
        //   } else {
        //     delete obj[name];
        //   }
        // } else {
        //   obj[name] !== undefined && delete obj[name];
        // }

        if (
          obj !== undefined &&
          obj !== null &&
          name !== "Email" &&
          name !== "MobileNo" &&
          name !== "FirstName" &&
          name !== "LastName" &&
          name !== "Age"
          //temp  &&name !== "IdNumber"
        ) {
          obj[name] !== undefined && obj[name] !== null && delete obj[name];
        }
      }
    }

    setFormErrors({ ...formErrors, [ind]: obj });
  };

  const dyncValidate = (errors) => {
    items.map((ele, ind) => {
      errors[ind] = {};
      arrItems.map((val) => {
        if (String(ele[val]).trim() === "") {
          let msg = val.split(/(?=[A-Z])/);
          if (msg.length > 1) {
            msg = msg.join(" ");
          }
          errors[ind][val] = `${msg} is required!`;
          if (msg[0] === "Dob") {
            errors[ind][val] = "Date of birth is required!";
          }
        }

        if (val === "Email") {
          if (errors[ind][val] === undefined && !emailRegex.test(ele.Email)) {
            errors[ind][val] = "Please enter a valid email!";
          }
        }

        if (val === "MobileNo") {
          if (
            errors[ind][val] === undefined &&
            ele?.MobileNo?.length >= 6 &&
            ele?.MobileNo?.length <= 10
          ) {
            errors[ind][val] = "Please Enter valid number!";
          } else if (!MobileRegex.test(ele?.MobileNo)) {
            errors[ind][val] = "Only numbers are allowed!";
          }
        }
      });

      if (inDyncValidate !== null && inDyncValidate !== undefined) {
        errors[ind] = inDyncValidate(errors[ind], ind, noSpCharsRegex);
      }

      errors[ind] !== undefined &&
        Object.keys(errors[ind]).length === 0 &&
        delete errors[ind];
    });
  };

  const validate = () => {
    let errors = {};
    const emailRegex = /[a-z0-9]+@[a-z]+\.[a-z]{2,3}/;

    if (state !== undefined && state !== null) {
      Object.keys(state).map((ele) => {
        if (state[ele] === "") {
          let msg = ele.split(/(?=[A-Z])/);
          if (msg.length > 1) {
            msg = msg.join(" ");
            msg = msg[0].charAt(0) + msg.slice(1);
            msg = msg.toLowerCase();
          }
          errors[ele] = `${msg} is required!`;
        }
      });
    }

    if (val?.hasOwnProperty("Email")) {
      if (errors?.Email === undefined && !emailRegex.test(state.Email)) {
        errors.Email = "Please enter a valid email!";
      }
    }

    if (val?.hasOwnProperty("MobileNo")) {
      // if (errors?.MobileNo === undefined && state?.MobileNo?.length !== 10) {
      //   errors.MobileNo = "Mobile Number Must be Exactly 10 Digits!";
      // } else if (!MobileRegex.test(state?.MobileNo)) {
      //   errors.MobileNo = "Only Numbers Are Allowed!";
      // }
      if (
        (errors?.MobileNo === undefined && state?.MobileNo?.length < 6) ||
        state?.MobileNo?.length > 10
      ) {
        errors.MobileNo = "Enter valid mobile number";
      } else if (!MobileRegex.test(state?.MobileNo)) {
        errors.MobileNo = "Only numbers are allowed!";
      }
    }

    if (inValidate !== null && inValidate !== undefined) {
      inValidate(errors, setState);
    }

    if (dyncVals !== null && dyncVals !== undefined) {
      dyncValidate(errors);
    }

    return errors;
  };

  const checkErrors = (e) => {
    let check = validate();
    let name = e.target.name;
    if (name in check) {
      setFormErrors({ ...formErrors, [name]: check[name] });
    } else {
      setFormErrors({ ...formErrors, [name]: "" });
    }
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    setFormErrors(validate());
    if (withSubmit !== null && withSubmit !== undefined) {
      withSubmit();
    }
    setIsSubmit(true);
  };

  return {
    state,
    formErrors,
    isSubmit,
    handleInputChange,
    handleFormSubmit,
    checkErrors,
    setIsSubmit,
    setState,
    setFormErrors,
    handleInputDynamic,
    checkDyncErrors,
    // setState,
  };
}
